import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
// RxJS
import { Subject } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Announcement } from '@shared/models/announcement.model';
import { ApiResponse } from '@shared/models/api-response.model';
import { Marquees } from '@shared/marquees.model';
import { Popup } from '@shared/models/popup.model';

@Injectable({
  providedIn: 'root'
})
export class AnnouncementHttpService {

  newPromptIncoming = new Subject();
  newVipPromptIncoming = new Subject();
  manualPromptIncoming = new Subject();

  static rewardPrompt: Announcement = null;
  static vipDialog: Announcement = null;
  static manualPrompt: Announcement = null;
  unsubscribeRewardPrompt: (() => void) | null = null;
  unsubscribeVipDialog: (() => void) | null = null;
  unsubscribeManualPrompt: (() => void) | null = null;

  private memberAccountId: number = null;

  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar,
    // private socketIoService: SocketIoService,
  ) {}

  async init(memberAccountId: number) {
    this.memberAccountId = memberAccountId;
    // this.updatePromptWebsocket(memberAccountId);
    // this.updateVipDialog(memberAccountId);
    // this.updateManualPopUpDialog(memberAccountId);
  }

  getAnnouncements(): Observable<Announcement[]>{
    return this.http.get<ApiResponse>(`/announcement`).pipe(
      map(res => res.data.rows)
    );
  }

  getMarquees(): Observable<Marquees[]>{
    return this.http.get<ApiResponse>(`/marquees`).pipe(
      map(res => res.data.rows)
    );
  }

  getMaintenance() {
    return this.http.get<ApiResponse>(`/gameprovider/maintenance`).pipe(
      map(res => res?.data ?? { rows: [] })
    );
  }

  getPopUp(dialogCode: any): Observable<Popup[]>{
    let params = '&code=';
    if (dialogCode !== null) {
      params = params + dialogCode;
    }
    else {
      params = '';
    }

    return this.http.get<ApiResponse>(`/popups?always_pop=1${params}` ).pipe(
      map(res => res.data.rows)
    );
  }

  updatePromotionPopupDialogLog(data: any): Observable<Popup[]>{
    return this.http.put<ApiResponse>(`/promotionpopupdialoglog/updateseen`, data).pipe(
      map(res => res.data.rows)
    );
  }

  // private updatePromptWebsocket(memberAccountId: number) {
  //   this.unsubscribeRewardPrompt = this.socketIoService
  //     .channel('update-reward-prompt-channel.' + memberAccountId)
  //     .listen('UpdateRewardPromptEvent', (data) => {
  //       AnnouncementHttpService.rewardPrompt = data;
  //       this.newPromptIncoming.next();
  //     });
  // }

  // private updateVipDialog(memberAccountId: number) {
  //   this.unsubscribeVipDialog = this.socketIoService
  //     .channel('update-vip-dialog-channel.' + memberAccountId)
  //     .listen('UpdateVipDialogEvent', (data) => {
  //       AnnouncementHttpService.vipDialog = data;
  //       this.newVipPromptIncoming.next();
  //       console.log(data, 'prompt')
  //     });
  // }

  // private updateManualPopUpDialog(memberAccountId: number) {
  //   this.unsubscribeManualPrompt = this.socketIoService
  //     .channel('update-manual-popup-dialog-channel.' + memberAccountId)
  //     .listen('UpdateManualPopupDialogEvent', (data: any) => {
  //       AnnouncementHttpService.manualPrompt = data;
  //       this.manualPromptIncoming.next(data);
  //     });
  // }

  disconnectSocket() {
    if (this.unsubscribeRewardPrompt) {
      this.unsubscribeRewardPrompt();
    }
    if (this.unsubscribeVipDialog) {
      this.unsubscribeVipDialog();
    }
    if (this.unsubscribeManualPrompt) {
      this.unsubscribeManualPrompt();
    }
    // this.socketIoService.leave('update-reward-prompt-channel.');
    // this.socketIoService.leave('update-vip-dialog-channel.');
    // this.socketIoService.leave('update-manual-popup-dialog-channel.' + this.memberAccountId);
    this.unsubscribeRewardPrompt = null;
    this.unsubscribeVipDialog = null;
    this.unsubscribeManualPrompt = null;
  }

}
